<template>
  <div>
    <div class="top-bar">
      <span>
        <i class="left" @click="back()"></i>
      </span>
      <span class="heading_new">{{$route.query.page}}</span>
      <span class="spacer" />
    </div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <div class="main-container">
      <div class="row">
        <div class="col-4">
          <txt label="Bill Number" name="bill_number" v-model="model.bill_number" />
        </div>
        <div class="col-4">
          <div class="label">
            <span class="input-label">Bill Date</span>
            <date-picker
              name="bill_date"
              :value="model.bill_date"
              @datevalue="(val)=> model.bill_date = val"
            />
          </div>
        </div>
        <div class="col-4">
          <tl-select
            label="For Month"
            :options="['January', 'February']"
            v-model="model.month"
            @change="(val) => model.month=val"
          ></tl-select>
        </div>
      </div>
      <div class="row margin-t-m">
        <div class="col-4">
          <txt label="Service  Provider" name="service_provider" v-model="model.service_provider" />
        </div>
        <div class="col-4">
          <txt
            label="Mobile Number"
            v-if="$route.query.page=='Telephone Reimbursement'"
            name="mobile_number"
            v-model="model.mobile_number"
          />
          <txt
            label="Account Number"
            v-if="$route.query.page!='Telephone Reimbursement'"
            name="account_number"
            v-model="model.account_number"
          />
        </div>
        <div class="col-4">
          <txt label="Bill Amount" type="number" name="bill_amount" v-model="model.amount" />
        </div>
        <div class="col-12 margin-t-m">
          <div
            class="upload-heading"
          >Upload the {{$route.query.page == 'Internet Reimbursement'?'internet':'monthly'}} phone bill</div>
          <upload @change="(val)=>docUrl=val.data.location" />
        </div>
        <div class="col-12 margin-t-m">
          <btn text="Add Bill" type="secondary" @click="addMore()" />
        </div>
      </div>

      <div class="margin-t-l">
        <data-table
          :columns="tableColumns"
          :tableData="billList"
          :showinrow="true"
          :showhistory="false"
          :showedit="false"
          @delete="deleteItem($event)"
        >
          <template v-slot:rowcontent="slotprops">
            <div>
              <p v-if="slotprops.value.column.key == 'srNo'">{{slotprops.value.index+1}}</p>
              <p
                v-if="slotprops.value.column.key == 'bill_number'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <p
                v-if="slotprops.value.column.key == 'bill_date'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <p
                v-if="slotprops.value.column.key == 'month'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <p
                v-if="slotprops.value.column.key == 'service_provider'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <p
                v-if="slotprops.value.column.key == 'mobile_number' && $route.query.page == 'Telephone Reimbursement'"
              >{{slotprops.value.record['mobile_number']}}</p>
              <p
                v-if="slotprops.value.column.key == 'account_number' && $route.query.page != 'Telephone Reimbursement'"
              >{{slotprops.value.record['account_number']}}</p>
              <p
                v-if="slotprops.value.column.key == 'amount'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <p
                v-if="slotprops.value.column.key == 'proofs'"
              >{{slotprops.value.record[slotprops.value.column.key].length}} attacment</p>
            </div>
          </template>
        </data-table>
      </div>
    </div>
    <pop-up-message
      v-if="showSuccessMsg"
      :message="`${$route.query.page} added succesfully.`"
      btnText="Back"
      @back="back"
    ></pop-up-message>
    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn text="Cancel" type="secondary" @click="back" />
          <btn text="Save" type="primary" @click="submit" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      showSuccessMsg: false,
      toast:false,
      errmsg:'',
      model: {
        bill_number: "",
        bill_date: "",
        month: "",
        service_provider: "",
        mobile_number: "",
        account_number: "",
        amount: 0
      },
      docUrl: "",
      tableColumns: [
        {
          label: "Sr. No.",
          key: "srNo"
        },
        {
          label: "Bill Number",
          key: "bill_number"
        },
        {
          label: "Bill Date",
          key: "bill_date"
        },
        {
          label: "Month",
          key: "month"
        },
        {
          label: "Service Provider",
          key: "service_provider"
        },
        {
          label: "Mobile Number",
          key: "mobile_number"
        },
        {
          label: "Amount",
          key: "amount"
        },
        {
          label: "Proofs",
          key: "proofs"
        }
      ],
      billList: []
    };
  },
  computed: {
    ...mapState("dashboard/organisation/utilities/itdeclarations", {
      trData: state => state.TR,
      irData: state => state.IR
    })
  },
  activated() {
    this.showSuccessMsg = false;
    if (this.$route.query.page == "Internet Reimbursement") {
      this.tableColumns[5] = {
        label: "Account Number",
        key: "account_number"
      };
      this.setIRData();
    } else {
      this.tableColumns[5] = {
        label: "Mobile Number",
        key: "mobile_number"
      };
      this.setTRData();
    }
  },
  methods: {
    ...mapActions({
      saveTRData: "dashboard/organisation/utilities/itdeclarations/saveTR",
      saveIRData: "dashboard/organisation/utilities/itdeclarations/saveIR"
    }),
    back() {
      this.$router.go(-1);
    },
    async submit() {
      try {
        if (this.$route.query.page == "Internet Reimbursement") {
          await this.saveIRData({
            id: this.$route.query.id,
            data: this.billList,
            proofs: this.billList.map(item => {
              return item.proofs[0];
            })
          });
        } else {
          await this.saveTRData({
            id: this.$route.query.id,
            data: this.billList,
            proofs: this.billList.map(item => {
              return item.proofs[0];
            })
          });
        }
        this.showSuccessMsg = true;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    setIRData() {
      try {
        if (this.irData[this.$route.query.id]) {
          this.billList = this.irData[this.$route.query.id].data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    setTRData() {
      try {
        if (this.trData[this.$route.query.id]) {
          this.billList = this.trData[this.$route.query.id].data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    addMore() {
      try {
        this.billList.push({
          bill_number: this.model.bill_number,
          bill_date: this.model.bill_date,
          month: this.model.month,
          service_provider: this.model.service_provider,
          account_number: this.model.account_number,
          amount: this.model.amount,
          mobile_number: this.model.mobile_number,
          proofs: [this.docUrl]
        });
        this.resetForm();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    resetForm() {
      try {
        this.model = {
          bill_number: "",
          bill_date: "",
          month: "",
          service_provider: "",
          mobile_number: "",
          account_number: "",
          amount: 0
        };
        this.docUrl = "";
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    deleteItem(record) {
      try {
        let index = this.billList.findIndex(item => item.name == record.name);
        this.billList.splice(index, 1);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.top-bar {
  height: auto;
  padding: 20px;
  background-color: #34c0be;
  display: flex;
}
.heading_new {
  width: auto;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
}
.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}

.d_heading {
  font-size: 14px;
  font-weight: 600;
  opacity: 0.68;
  color: #646464;
}
.upload-heading {
  font-size: 13px;
  font-weight: 500;
}
</style>
